import { PacketValueSerialType } from "../../../enum/PacketValueSerialType";
import Vector2 from "../../../math/Vector2";
import { FlakShard } from "../../FlakShard";
import Gun from "../../Gun";
import Player from "../../Player";

export default class FlakDisperser extends Gun {

    spreadAngle = 0.5236;

    constructor(player: Player) {
        super(player, {
            damage: 30,
            fireRate: 1,
            reloadTime: 5,
            bulletSpeed: 64,
            magSize: 8,
            mouseTrigger: 2
        });
    }

    onShoot(): void {
        
        const tL = this.player.transform.forward.rotate(-this.spreadAngle/2).angle;
        const tR = tL + this.spreadAngle

        for (let i = tL; i < tR; i += (tR - tL)/5) {
            const vec = Vector2.fromRadians(i);
            const spawnPos = this.player.transform.position.add(vec.scale(this.player.size + 4));
            const [, shard] = this.player.engine.NewGameObjectWithScript<FlakShard>(FlakShard);
            shard.transform.position = spawnPos;
            shard.velocity = this.player.velocity.add(vec.scale(this.bulletSpeed));
            shard.ownerName = this.player.name;
            shard.team = this.player.team;
            shard.damage = this.damage;

            this.player.engine.sendCreatePacket(shard.gameObject, {
                type: "FLAK_SHARD",
                values: [
                    {
                        key: "velocity",
                        value: shard.velocity,
                        type: PacketValueSerialType.Vector2
                    },
                    {
                        key: "ownerName",
                        value: shard.ownerName,
                        type: PacketValueSerialType.String
                    },
                    {
                        key: "team",
                        value: shard.team || "",
                        type: PacketValueSerialType.String
                    },
                    {
                        key: "damage",
                        value: shard.damage,
                        type: PacketValueSerialType.UInt
                    },
                ]
            });
        }

    }
}